export const frontlinki = {
  items: [
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&sort=3&order=ASC",
      linkb: "",
      nazwa: "top",
      pozycja: "1",
      tytul: "Polecane oferty"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&dni=150",
      linkb: "/wakacje/oferty.xml?dojazd=samolot&pobyt=6,14&dni=150",
      nazwa: "lm",
      pozycja: "2",
      tytul: "Chiny"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=13,15&dni=160",
      linkb: "/wakacje/oferty.xml?dojazd=samolot&pobyt=13,15&dni=160",
      nazwa: "allInclusive",
      pozycja: "3",
      tytul: "Chiny w dwa tygodnie"
    }
  ]
};
